import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import {
  Dashboard,
  Login,
  Navbar,
  OrderCheckout,
  Orders,
  Session,
  UserProfile,
} from "./Components/index";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import HtmlViewer from "./Components/Screens/HtmlViewer";
import ProductRequest from "./Components/Session/ProductRequest/ProductRequest";
import InventoryOnboard from "./Components/Session/Inventory/InventoryOnboard";
import Credit from "./Components/Credit/Credits";
import { detectWebDeviceType } from "./utils";
import ScrollToTop from "./Components/ScrollToTop";

const PrivateRoute = ({ children }) => {
    const deviceType = detectWebDeviceType();
  const { user } = useSelector((state) => state?.login);
  return user ? (
    <>
      <Navbar />
      <div className={`${deviceType=="tablet"?"mt-20":"mt-24"}`}>{children}</div>
    </>
  ) : (
    <Navigate to="/login" />
  );
};

const LoginExist = ({ children }) => {
  const { user } = useSelector((state) => state?.login);
  return !user ? children : <Navigate to="/session" />;
};

const ProjectRoutes = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  // const showDash = useSelector(
  //   (state) => state?.login?.user?.result?.is_dashboard_show
  // );
  // const showOrders = useSelector(
  //   (state) => state?.login?.user?.result?.show_orders
  // );
  // const showCredit = useSelector(
  //   (state) => state?.login?.user?.result?.show_credit
  // );

  const showDash = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_dashboard_show
  );

  const showOrders = useSelector(
    (state) => state?.permissionReducer?.permissions?.show_orders
  );
  const showCredit = useSelector(
    (state) => state?.permissionReducer?.permissions?.show_credit
  );

  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        {showDash === true && (
          <Route
            path={`/dashboard`}
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
        )}
        {/* {showOrders === true && ( */}
          <Route
            path={`/orders`}
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
        {/* )} */}
        {showCredit === true && (
          <Route
            path={`/credit`}
            element={
              <PrivateRoute>
                <Credit />
              </PrivateRoute>
            }
          />
        )}
        <Route
          path={`/ordercheckout`}
          element={
            <PrivateRoute>
              <OrderCheckout />
            </PrivateRoute>
          }
        />
        <Route
          path={`/session`}
          element={
            <PrivateRoute>
              <Session />
            </PrivateRoute>
          }
        />
        <Route
          path={`/userprofile`}
          element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          }
        />
        <Route
          path={`/login`}
          element={
            <LoginExist>
              <Login />
            </LoginExist>
          }
        />
        <Route path={`/geidea`} element={<HtmlViewer />} />
        <Route
          path={`/pos/ProductRequest`}
          element={
            <PrivateRoute>
              <ProductRequest />
            </PrivateRoute>
          }
        />
        <Route
          path={`/pos/InventoryUpdate`}
          element={
            <PrivateRoute>
              <InventoryOnboard />
            </PrivateRoute>
          }
        />
        {/* Redirect root path to language-specific path */}
        <Route path="/" element={<Navigate to={`/session`} />} />
        {/* Catch-all route to handle unknown paths */}
        <Route path="*" element={<Navigate to={`/session`} />} />
      </Routes>
    </Router>
  );
};

export default ProjectRoutes;
